<script>
	const page = require('page');
	const model = require('model/model');
	const Q = require('q');
	const utilities = require('utilities');
	const pubsub = require('events/pubsub');

	module.exports = {
		components: {
			'google-classroom-import-form': require('components/google-classroom-import-form.vue').default
		},
		methods: {
			afterGoogleImport(v) {
				let prms = Q();

				if (v && v.cc) {
					prms.then(() => {
						if (model.get('gcAddon')) {
							page('/find-content');
							return;
						}

						page('/class-admin');
						model.set({
							classAdmin: 'roster',
							classCode: v.cc
						});
						model.set({
							showGCImportDialog: v
						});
						pubsub.publish('update-classes');
					});
				}

				return prms;
			},
			close() {
				utilities.closeModals();
			},
			backToClassChoice() {
				utilities.openModal('#modal-create-class');
			}
		},
		mounted() {
			this.$subscribe('modal-opened', (modalId, opts) => {
				if (modalId !== 'modal-google-classroom-import') {
					return true; // let some other handler take this
				}

				if (this.$refs.googleForm) {
					this.$refs.googleForm.loadClasses();
				}

				return false;
			});

			this.$subscribe('modal-closed', (modalId, opts) => {
				if (modalId !== 'modal-google-classroom-import') {
					return true; // let some other handler take this
				}

				this.loading = false;
				return false;
			});
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	#modal-google-classroom-import {
		.modal-content-header {
			position: relative;

			.modal-back {
				position: absolute;
				left: 0;
				font-size: 2rem;
				line-height: 1.5rem;
				cursor: pointer;
			}
		}

		.google-classroom-import {
			form.validated-form {
				select + label {
					text-align: left;
				}
			}
		}
	}
</style>
<template>
	<modal
		ref="modal"
		id="modal-google-classroom-import"
		:ok="false"
		:centered="true">
		<div slot="header-container">
			<button
				class="modal-back button -link"
				aria-label="Back to Class Choice"
				@click="backToClassChoice">
				&larr;
			</button>
			<h2>Google Classroom Import</h2>
		</div>
		<div
			slot="content"
			class="google-classroom-import">
			<google-classroom-import-form
				ref="googleForm"
				:on-cancel-click="close"
				:after-import="afterGoogleImport">
			</google-classroom-import-form>
		</div>
	</modal>
</template>
